import styled from 'styled-components';

const CardWrapper = styled.div`
	position: absolute;
	top: 0;
	bottom: 12px;
	left: 6px;
	right: 6px;
	mask-image: linear-gradient(
		90deg,
		rgba(0, 0, 0, 0) 0,
		rgba(0, 0, 0, 1) 12px,
		rgba(0, 0, 0, 1) calc(100% - 12px),
		rgba(0, 0, 0, 0) 100%
	);
`;

const MediaCardWrapper = ({ children }) => {
	return <CardWrapper>{children}</CardWrapper>;
};

export default MediaCardWrapper;
